<!--华普定制头部-->
<template>
	<div class="hpTitleBody" v-bind:style="backImg">
		<div class="serviceTerm">
			<img :src="imgName('huapu/serviceTerm.png')" />
			<span>服务期限:</span>
			<span :style="timeJudge">{{new Date(nowUnit.expirationTime).format('yyyy-MM-dd')}}</span>
		</div>
		<div class="hpUserTitle flexCenterColumn">
			<span>{{nowUnit.fullName}}</span>
			<img :src="imgName('huapu/userTitle.png')" />
		</div>
		<div style="padding-right: .2rem;">
			<img :src="imgName('huapu/phone.png')" />
			<span>服务电话:</span>
			<div class="flexCenterColumn">
				<span>021-5955555</span>
				<span>15821562306</span>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return {
					'background-image': 'url(' + this.imgName('huapu/background.png') + ')'
				}
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			timeJudge() {
				var expirationTime = new Date(this.nowUnit.expirationTime).getTime()
				var currentTime = new Date()
				//计算后的时间
				var calculatingTime = (expirationTime - currentTime) / 1000 / 60 / 60 / 24
				if (calculatingTime > 15) {
					return {
						'color': '#4eb11e'
					}
				} else if (calculatingTime <= 0) {
					return {
						'color': 'red'
					}
				} else if (calculatingTime <= 15) {
					return {
						'color': '#d4d022'
					}
				}
			}
		},
		watch: {},
		methods: {}
	}
</script>

<style scoped>
	.hpTitleBody {
		margin: 5px 0;
		background-size: 10%;
		width: 100%;
		height: calc(8% - 10px);
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.hpTitleBody img {
		width: .3rem;
	}

	.hpTitleBody div {
		display: flex;
		align-items: center;
	}

	.hpTitleBody span {
		color: white;
	}

	.hpUserTitle {
		width: 40%;
		height: 100%;
	}

	.hpUserTitle span {
		padding-top: 2px;
		font-size: .18rem;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
		text-align: center;
		overflow: hidden;
	}

	.hpUserTitle img {
		width: 100%;
		padding-top: 2px;
	}

	.serviceTerm {
		padding-left: .2rem;
	}

	.serviceTerm img,
	span {
		padding-left: .1rem;
	}
</style>
